import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import {Link} from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import svgEyeOpen from '../../svgs/View_default.svg';
import svgEyeClosed from '../../svgs/View_off_default.svg';
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import dollars from "../../dollar-format";
import {addSpaceAfterComma} from '../../utils';
import {BUYERS_LIST, BUYERS_LIST_COUNT} from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";

let cloneDeep = require('lodash.clonedeep');
let find = require('lodash.find');

const limit = 50;
const defaultSubcatNo = 3;

export default class BuyerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };

        this.expandRow = this.expandRow.bind(this);
    }

    componentDidMount() {
        this.fetch(this.props.location.query);
    }

    fetch(q) {
        this.setState({isBusy: true});

        const query = {...q};
        if (!this.props.isSuper && !query.STATUS) {
            query.STATUS = '1031-Buyer,Active';
        }
        const options = filter(query, 'buyers');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        Promise.all([
            executeQuery({queryName: BUYERS_LIST, options: options}),
            executeQuery({queryName: BUYERS_LIST_COUNT, options: options})
        ]).then(res => {
            const items = res[0].data.map(el => {
                el.IS_EXPANDED = false;
                return el;
            });
            this.setState({
                items,
                totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
                error: res[0].success ? null : res[0].message,
                isBusy: null,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    expandRow(el) {
        const items = cloneDeep(this.state.items);
        const item = find(items, {ARCIMEDES_ROW_ID: el.ARCIMEDES_ROW_ID});
        item.IS_EXPANDED = !item.IS_EXPANDED;
        this.setState({items});
    }

    render() {
        const query = this.props.location.query;
        const columns = [{
            name: 'View',
            textAlign: 'center',
            columnStyle: {
                width: 70
            },
            render: (el) => {
                if (this.props.isSuper)
                    return <Link to={{pathname: `${arc.path.base}buyer/${el.ARCIMEDES_ROW_ID}`}}><Icon svg={svgEdit}/></Link>
                return <div className='icon-normal' style={{cursor: 'pointer'}} onClick={() => this.expandRow(el)}><Icon svg={el.IS_EXPANDED ? svgEyeClosed : svgEyeOpen}/></div>
            },
        },];

        if (!this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.STRIVE_AGENT_LAST_NAME,
            },)
        }

        columns.push({
            code: 'STATUS',
            name: 'Status',
            render: (el) => el.STATUS,
        }, {
            code: 'CATEGORY',
            name: 'Category',
            render: (el) => el.CATEGORY ? addSpaceAfterComma(el.CATEGORY) : '',
        }, {
            code: 'TYPE',
            name: 'Type',
            render: (el) => el.TYPE ? addSpaceAfterComma(el.TYPE) : '',
        }, {
            code: query.TYPE === 'MT' ? 'MULTI_TENANT_SUBCATEGORY' : 'SINGLE_TENANT_SUBCATEGORY',
            name: 'Subcategory',
            render: (el) => {
                let value = '';
                if (el.TYPE === 'MT' && el.MULTI_TENANT_SUBCATEGORY)
                    value = addSpaceAfterComma(el.MULTI_TENANT_SUBCATEGORY);
                if (el.TYPE === 'STNL' && el.SINGLE_TENANT_SUBCATEGORY)
                    value = addSpaceAfterComma(el.SINGLE_TENANT_SUBCATEGORY);
                if (!el.IS_EXPANDED && (value.match(/,/g) || []).length > defaultSubcatNo - 1)
                    return `${value.split(',', defaultSubcatNo).join()}...`;
                return value;
            }
        }, {
            code: 'MARKET',
            name: 'Market',
            render: (el) => el.MARKET ? addSpaceAfterComma(el.MARKET) : '',
        }, {
            name: 'Price',
            subColumns: [{
                code: 'PRICE_MIN',
                name: 'Min',
                textAlign: 'right',
                render: (el) => el.PRICE_MIN ? dollars(el.PRICE_MIN) : ''
            }, {
                code: 'PRICE_MAX',
                name: 'Max',
                textAlign: 'right',
                render: (el) => el.PRICE_MAX ? dollars(el.PRICE_MAX) : ''
            }],
            headerStyle: {
                minWidth: 130,
                justifyContent: 'center',
            },
            render: () => '',
        }, {
            name: 'Cap Rate',
            subColumns: [{
                code: 'CAP_RATE_MIN',
                name: 'Min',
                textAlign: 'right',
                render: (el) => el.CAP_RATE_MIN ? `${el.CAP_RATE_MIN}%` : ''
            }, {
                code: 'CAP_RATE_MAX',
                name: 'Max',
                textAlign: 'right',
                render: (el) => el.CAP_RATE_MAX ? `${el.CAP_RATE_MAX}%` : ''
            }],
            headerStyle: {
                minWidth: 80,
                justifyContent: 'center',
            },
            render: () => '',
        },{
            name: 'Buyer',
            subColumns: [{
                code: 'FIRST_NAME',
                name: 'First Name',
                render: (el) => el.FIRST_NAME,
            }, {
                code: 'LAST_NAME',
                name: 'Last Name',
                render: (el) => el.LAST_NAME,
            }],
            headerStyle: {
                minWidth: 218,
                justifyContent: 'center'
            },
        }, {
            code: 'EMAIL',
            name: 'Email',
            render: (el) => el.EMAIL ? <a href={`mailto:${el.EMAIL}`}>{el.EMAIL}</a> : null,
        }, {
            code: 'PHONE',
            name: 'Phone',
            columnStyle: {
                minWidth: 132,
            },
            render: (el) => el.PHONE ?
                <a href={`tel:${el.PHONE.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.PHONE}</a> : null,
        }, {
            code: 'COMPANY_NAME',
            name: 'Company Name',
            render: (el) => el.COMPANY_NAME,
        });

        if (this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.STRIVE_AGENT_LAST_NAME,
            })
        }

        return (
            <div className='BuyerList' data-is-busy={this.state.isBusy}>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container list'>
                        <div className='page-header list'>
                            <div className='page-title'>Buyers</div>
                            <LinkComp to={`${arc.path.base}buyer`}>
                                <div className="button-new plus positive">
                                    <Icon svg={plus}/>
                                </div>
                            </LinkComp>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='page-body-container'>
                    <SortTable columns={columns}
                               classNameModifier={this.props.isSuper ? 'buyers-admin' : 'buyers-agent'}
                               items={this.state.items}
                               query={query}
                               hasSubColumns={true}
                    />
                    <ListResults query={this.props.location.query}
                                 pathname={this.props.location.pathname}
                                 error={this.state.error}
                                 totalCount={this.state.totalCount}
                                 itemCount={this.state.items ? this.state.items.length : false}
                                 limit={limit}
                                 className="buyer"
                    />
                </div>
            </div>
        );
    }
}
